<div class="chart-container" #chartContainer [style.height.px]="graphHeight()">
    <ngx-charts-bar-horizontal-stacked
        [view]="[chartContainer.offsetWidth, chartContainer.offsetHeight]"
        [scheme]="colorScheme"
        [results]="results()"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [showDataLabel]="showDataLabel"
        [showGridLines]="showGridLines"
        [barPadding]="barPadding"
        [xAxisTickFormatting]="removeDecimalXAxisValues"
        [noBarWhenZero]="false"
        (select)="viewDetails.emit($event)" />
</div>
